export const Status = Object.freeze({
  LOADING: '@@status.loading',
  VALID: '@@status.valid',
  ERROR: '@@status.ERROR',
});
